import React from 'react';
import {ServerNotificationProps} from '@src/components/Notifications/server-notifications/ServerNotification';
import {INotificationProps} from '@src/@interfaces/components/Notifications/INotificationProps';
import app from '@src/helpers/app';
import getUri from '@src/helpers/getUri';
import OrderStatusRepresentation from '@src/components/StatusRepresentations/OrderStatusRepresentation';
import InfoNotification from '@src/components/Notifications/InfoNotification';
import {getProductionDashboardUrlIfPossible} from './getProductionDashboardUrlIfPossible';
import {
    getManagerDashboardProductsListSearchParams
} from '@src/components/Notifications/server-notifications/Order/Product/getManagerDashboardProductsListSearchParams';
import {
    getSearchTermParams
} from '@src/components/Notifications/server-notifications/Order/Product/getSearchTermParams';
import makeUrl from '@src/components/Notifications/server-notifications/makeUrl';

export default class StatusChanged extends InfoNotification<
        ServerNotificationProps<'App\\Notifications\\Order\\Product\\StatusChanged'> &
        INotificationProps
> {
    protected getWrapperTagProps(): any {
        const payload = this.props.notification.data;
        const namesResolver = app('names-resolver').clientRoutes;

        const getSearchParams = (params: Record<string, string>) => {
            return getSearchTermParams('OrderProducts', String(payload.orderId), params);
        };

        let toUrl = getProductionDashboardUrlIfPossible(payload.orderProductId);
        if (!toUrl) {
            toUrl = getUri({
                route: namesResolver.getShowRouteName('Orders'),
                params: {
                    id: String(payload.orderId),
                },
            });
        }

        const searchParams = getSearchParams(
                getManagerDashboardProductsListSearchParams({
                    productId: String(payload.orderProductId ?? 0),
                })
        );

        return {
            ...super.getWrapperTagProps(),
            to: makeUrl({url: toUrl, searchParams, hash: '#OrdersShow.tabs.products'}),
        };
    }

    protected getDescriptionReplacements() {
        const data = this.props.notification.data;
        const getStatus = (status?: typeof data['was']) => {
            return !status ? '—' : <OrderStatusRepresentation
                    label={status.title}
                    bgColor={status.bg_color}
                    textColor={status.text_color}
            />;
        };

        return {
            ...data,
            oldStatus: getStatus(data.was),
            newStatus: getStatus(data.became),
        };
    }
}
